import React from 'react';
import ReactPlayer from 'react-player';

export class VideoWidget extends React.Component {
  findVideo = (ranges, heartRate) => {
    let player = <></>;
    for (let index in ranges) {
      let range = ranges[index];
      if (range.from <= heartRate && range.to >= heartRate && range.file.url) {
        player = (
          <ReactPlayer
            height={'7em'}
            width={'7em'}
            loop={true}
            muted={true}
            playing={true}
            controls={false}
            url={range.file.url}
          />
        );
        break;
      }
    }

    return player;
  };

  render() {
    let video;
    if (this.props.configuration) {
      video = this.findVideo(this.props.configuration.ranges, this.props.pulse);
    } else {
      video = <></>;
    }

    return (
      <>
        {this.props.configuration && (
          <div className={'fill-window'}>{video}</div>
        )}
      </>
    );
  }
}
